import React from 'react'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import TourInner from '../Components/Tour/TourInner'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import SEO from '../Components/SEO/SEO'

function Tour() {
    return (
        <>
            <SEO 
                title="Popular Tours - Tourm Travel Agency"
                description="Explore our popular tours and travel packages. Find the perfect tour for your next vacation adventure."
                url="/tour"
            />
            <HeaderOne />
            <Breadcrumb
                title="Popular Tours"
            />
            <TourInner />
            <FooterFour />
            <ScrollToTop />
        </>
    )
}

export default Tour
